module.exports = __webpack_public_path__ + "img/icon-inbox.4251382f.svg";